<template>
  <div>
    <form-wizard
      title=""
      subtitle=""
      color="#007bff"
      stepSize="xs"
      ref="contractWizard"
      @on-change="onWizardTabChange"
      @on-complete="onCompleteContractWizard">
      <tab-content
        :title="$t('message.contractWizard.tabContent.contractPartner')"
        icon="ti-agenda"
        :before-change="validateContractPartner">
        <contract-partner-details
          ref="contractPartnerDetails">
        </contract-partner-details>
      </tab-content>

      <tab-content
        :title="$t('message.contractWizard.tabContent.contractInformation')"
        icon="ti-id-badge"
        :before-change="validateContractInformation">
        <contract-information-details
          ref="contractInformationDetails">
        </contract-information-details>
      </tab-content>

      <tab-content
        :title="$t('message.contractWizard.tabContent.contractAddress')"
        icon="ti-home"
        :before-change="validateContractAddress"
        :after-change="verifyContractInformation">
        <contract-address-details></contract-address-details>
      </tab-content>

      <tab-content
        :title="$t('message.contractWizard.tabContent.contractEstate')"
        icon="ti-files"
        :beforeChange="validateContractEstate">
        <contract-estate-details></contract-estate-details>
      </tab-content>
      <div slot="custom-buttons-left">
        <b-btn
          v-if="showBtnContractPartnerCancel"
          class="rounded-0"
          variant="danger"
          @click="onCancelWizard">
          {{ $t('message.contractWizard.btn.cancel') }}
        </b-btn>
      </div>
      <div
        v-if="currentContract.id && currentContract.id != -1"
        slot="custom-buttons-right"
        class="float-left mr-3">
        <b-btn
          class="rounded-0"
          v-b-modal.deleteContractModal>
          {{ $t('message.contractWizard.btn.delete') }}
        </b-btn>
      </div>
      <b-btn
        class="rounded-0"
        slot="prev"
        variant="link"
        @click="onWizardPrevClicked">
        {{ $t('message.contractWizard.btn.prev') }}
      </b-btn>
      <b-btn
        class="rounded-0"
        variant="primary"
        slot="next">
        {{ $t('message.contractWizard.btn.next') }}
      </b-btn>
      <b-btn
        class="rounded-0"
        variant="primary"
        slot="finish">
        {{ $t('message.contractWizard.btn.finish') }}
      </b-btn>
    </form-wizard>
    <b-modal
      id="deleteContractModal"
      ref="deleteContractModal"
      centered
      ok-variant="primary"
      :title="$t('message.contractWizard.deleteContractModal.title')"
      :ok-title="$t('message.contractWizard.deleteContractModal.btn.ok')"
      :cancel-title="$t('message.contractWizard.deleteContractModal.btn.cancel')"
      @ok="onDeleteContract">
      {{ $t('message.contractWizard.deleteContractModal.message') }}
    </b-modal>
    <b-modal
      id="contractWizardModal"
      ref="contractWizardModal"
      centered
      ok-only
      ok-variant="primary"
      :title="$t('message.contractWizard.contractWizardModal.title')"
      :ok-title="$t('message.contractWizard.contractWizardModal.btn.submit')">
      <span v-html="$t('message.contractWizard.contractWizardModal.message')"></span>
    </b-modal>
  </div>
</template>

<script>
  import {FormWizard, TabContent} from 'vue-form-wizard'
  import ContractAddressDetails from '@/components/contracts/ContractAddressDetails'
  import ContractEstateDetails from '@/components/contracts/ContractEstateDetails'
  import ContractInformationDetails from '@/components/contracts/ContractInformationDetails'
  import ContractPartnerDetails from '@/components/contracts/ContractPartnerDetails'
  import 'vue-form-wizard/dist/vue-form-wizard.min.css'

  export default {
    name: 'ContractWizard',
    components: {
      ContractAddressDetails,
      ContractEstateDetails,
      ContractInformationDetails,
      ContractPartnerDetails,
      FormWizard,
      TabContent
    },
    computed: {
      currentContract () {
        return this.$store.getters.currentContract
      },
      showBtnContractPartnerCancel () {
        if (this.currentContract.contractPartner &&
          this.currentContract.contractPartner.id &&
          (this.prevWizardTabIndex === -1 || this.nextWizardTabIndex === 0)) {
          return true
        }
        return false
      }
    },
    data () {
      return {
        prevWizardTabIndex: -1,
        nextWizardTabIndex: 0
      }
    },
    methods: {
      onCancelWizard () {
        this.$store.commit('setCurrentContract', {})
        this.$router.push('/contracts')
      },
      onCompleteContractWizard () {
        const handleSuccess = (isComplete) => {
          if (!isComplete) {
            this.$refs.contractWizardModal.show()
          }
          const contractInfoDetails = this.$refs.contractInformationDetails
          const contractInfoFrom = contractInfoDetails.$refs.contractInformationForm
          this.$refs.contractWizard.reset()
          this.$refs.contractPartnerDetails.resetContractPartner()
          this.showSuccessMsg({
            message: this.$t('message.contractList.createContract')
          })
          this.$store.commit('setCurrentContract', {
            contractCategory: null
          })
          this.$router.push('/contracts')
          setTimeout(() => {
            contractInfoFrom.resetValidation()
          }, 500)
        }
        if (this.currentContract.id && this.currentContract.id !== -1) {
          const contractPartner = this.$refs.contractPartnerDetails.getContractPartner()
          this.$store.dispatch('updateContractPartner', contractPartner)
            .then(() => (this.$store.dispatch('updateContract', this.currentContract)))
            .then((isComplete) => handleSuccess(isComplete))
            .catch(() => {
              this.showErrorMsg({
                message: this.$t('error.contractWizard.storeContract')
              })
            })
        } else {
          const contractPartner = this.$refs.contractPartnerDetails.getContractPartner()
          this.$store.dispatch('storeContractPartner', contractPartner)
            .then((response) => {
              this.$store.commit('updateContractPartner', response)
              return this.$store.dispatch('storeContract', this.currentContract)
            })
            .then((isComplete) => {
              handleSuccess(isComplete)
            })
            .catch(() => {
              this.showErrorMsg({
                message: this.$t('error.contractWizard.storeContract')
              })
            })
        }
      },
      onDeleteContract () {
        this.$store.dispatch('deleteContract', this.currentContract.id)
          .then(() => {
            this.showSuccessMsg({
              message: this.$t('message.contractWizard.deleteContract')
            })
            this.$store.commit('setCurrentContract', {})
            this.$router.push('/contracts')
          })
          .catch(() => {
            this.showErrorMsg({
              message: this.$t('error.contractWizard.deleteContract')
            })
          })
      },
      onWizardTabChange (prevIndex, nextIndex) {
        this.$emit('wizardChange', nextIndex)
        this.prevWizardTabIndex = prevIndex
        this.nextWizardTabIndex = nextIndex
      },
      onWizardPrevClicked () {
        const wizard = this.$refs.contractWizard
        if (this.currentContract.contractCategory === 'ONLINE_SUBSCRIPTION_AND_SOCIAL_MEDIA_ACCOUNT' && wizard.isLastStep) {
          wizard.prevTab()
        }
      },
      validateContractAddress () {
        const vm = this
        return new Promise((resolve, reject) => {
          vm.$store.commit('setCurrentContract', vm.currentContract)
          resolve(true)
        })
      },
      validateContractEstate () {
        const vm = this
        return new Promise((resolve, reject) => {
          vm.$store.commit('setCurrentContract', vm.currentContract)
          resolve(true)
        })
      },
      validateContractInformation () {
        const vm = this
        return new Promise((resolve, reject) => {
          const contractInfoDetails = vm.$refs.contractInformationDetails
          const contractInfoForm = contractInfoDetails.$refs.contractInformationForm
          contractInfoForm.$v.$touch()
          if (contractInfoForm.$v.$invalid) {
            reject(this.showErrorMsg({
              message: this.$t('error.contractList.check')
            }))
          }
          vm.$store.commit('setCurrentContract', vm.currentContract)
          resolve(true)
        })
      },
      validateContractPartner () {
        return new Promise((resolve, reject) => {
          const contractPartnerDetails = this.$refs.contractPartnerDetails
          contractPartnerDetails.stashContractPartner()
          if (!this.currentContract.contractPartner && !contractPartnerDetails.getContractPartner().searchValue) {
            this.showErrorMsg({
              message: this.$t('error.contractList.missing')
            })
            reject(false)
          } else if (!this.currentContract.contractPartner && contractPartnerDetails.getContractPartner().searchValue) {
            this.showErrorMsg({
              message: this.$t('error.contractList.noContractPartnerFounded')
            })
            contractPartnerDetails.createEmptyContractPartner()
            reject(false)
          } else if (this.currentContract.contractPartner) {
            contractPartnerDetails.$v.$touch()
            if (!contractPartnerDetails.$v.$invalid) {
              // const contractPartner = contractPartnerDetails.getContractPartner()
              // this.$store.dispatch('storeContractPartner', contractPartner)
              //   .then((contractPartner) => {
              //     this.$store.commit('updateContractPartner', contractPartner)
              resolve(true)
              //   })
              //   .catch(() => {
              //     this.showErrorMsg({
              //       message: this.$t('error.contractList.create')
              //     })
              //     reject(false)
              //   })
            } else {
              this.showErrorMsg({
                message: this.$t('error.contractList.invalid')
              })
              reject(false)
            }
          } else {
            resolve(true)
          }
        })
      },
      verifyContractInformation () {
        if (this.currentContract.contractCategory === 'ONLINE_SUBSCRIPTION_AND_SOCIAL_MEDIA_ACCOUNT') {
          this.currentContract.address = undefined
          this.currentContract = {...this.currentContract}
          this.$store.commit('setCurrentContract', this.currentContract)

          const wizard = this.$refs.contractWizard
          const activeTabIndex = wizard.activeTabIndex
          if (this.prevWizardTabIndex > activeTabIndex) {
            wizard.prevTab()
          }

          if (this.prevWizardTabIndex < activeTabIndex) {
            this.$refs.contractWizard.nextTab()
          }
        }
      }
    },
    notifications: {
      showErrorMsg: {
        type: 'error'
      },
      showSuccessMsg: {
        type: 'success'
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/contracts/ContractWizard.vue